import React, { useCallback, useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import Select from "react-select";
import { Container, Row, Col, Button } from "react-bootstrap";
import { ChevronLeft, ChevronRight, User } from "lucide-react";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import Image from "../../components/Image";
import Paginator from "../../components/Paginator";
import NoResultAnimation from "../../assets/animations/No Result Green theme.json"
import Lottie from "lottie-react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";

const Recruitment = () => {
      const { t, i18n } = useTranslation();


  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [recruitmentData, setRecruitmentData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    total_pages: 1,
    current_page: 1,
  });
  const [filters, setFilters] = useState({
    search: "",
    category_ids: "",
    sub_category_ids: "",
    daterange: { start: null, end: null },
  });
  const fetchDashboardDataDebounced = useCallback(
  debounce((newFilters) => {
    fetchDashboardData(1, newFilters);
  }, 500), // 500ms debounce
  []
);

  useEffect(() => {
    fetchDashboardData(1);
  }, []);
  useEffect(() => {
    (async () => {
      try {
        const res = await ApiService.request({
          method: "GET",
          url: "/getSkills",
        });

        console.log("API Response:", res.data);

        const categoriesArray = res.data.data.skills;
        if (Array.isArray(categoriesArray)) {
          const formattedOptions = categoriesArray.map((cat) => ({
            value: cat._id,
            label: cat.title,
          }));
  
          // Append the 'Other' option
          // formattedOptions.push({ value: "other", label: "Other" });
          setCategoryOptions(formattedOptions);
        } else {
          toast.error("Categories not in expected format");
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
        toast.error("Failed to load categories");
      }
    })();
  }, []);

    useEffect(() => {
    if (!filters.category_ids) {
      setSubCategoryOptions([]);
      setFilters((prev) => ({ ...prev, sub_category_ids: "" }));
      return;
    }

    (async () => {
      try {
        const res = await ApiService.request({
          method: "GET",
          url: `/getSubSkills?skill_id=${filters.category_ids}`,
        });

        const subCategoriesArray = res.data.data.skills;
        if (Array.isArray(subCategoriesArray)) {
          const formattedOptions = subCategoriesArray.map((sub) => ({
            value: sub._id,
            label: sub.title,
          }));
          setSubCategoryOptions(formattedOptions);
        } else {
          setSubCategoryOptions([]);
          toast.error("Sub-skills not in expected format");
        }
      } catch (err) {
        console.error(err);
        setSubCategoryOptions([]);
        toast.error("Failed to load sub-skills");
      }
    })();
  }, [filters.category_ids]);
  console.log("Dashboard Data:", recruitmentData);

const fetchDashboardData = async (page = 1, appliedFilters = filters) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);

    if (appliedFilters.search) params.append("search", appliedFilters.search);
    if (appliedFilters.category_ids)
      params.append("skill_ids", appliedFilters.category_ids);
    
    // Add sub_skill_ids parameter
    if (appliedFilters.sub_category_ids && appliedFilters.sub_category_ids.length > 0)
      params.append("sub_skill_ids", appliedFilters.sub_category_ids.join(','));

 const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; 
    };
    if (appliedFilters.daterange.start) {
      const start = formatDate(appliedFilters.daterange.start);
      if (start) params.append("daterange[start]", start);
    }

    if (appliedFilters.daterange.end) {
      const end = formatDate(appliedFilters.daterange.end);
      if (end) params.append("daterange[end]", end);
    }

    setIsLoading(true);
    const res = await ApiService.request({
      method: "GET",
      url: `company/getAcceptedProjects?${params}`,
    });

    const data = res.data;
    if (data.status) {
      setRecruitmentData(data?.data?.projects);
      setPagination(data?.data?.pagination ? data?.data?.pagination : 1);
    } else {
      toast.error(data.message);
    }
  } catch (err) {
    console.error("Fetch Job Error:", err);
    toast.error("Failed to fetch jobs.");
  } finally {
    setIsLoading(false);
  }
};


  const handlePageChange = (page) => {
    if (
      page !== pagination.current_page &&
      page >= 1 &&
      page <= pagination.total_pages
    ) {
      fetchDashboardData(page);
    }
  };

  const { current_page, total_pages } = pagination;

  // Generate page numbers (for large datasets show 1,2,3,...,last)
  const getPages = () => {
    const pages = [];

    if (total_pages <= 5) {
      for (let i = 1; i <= total_pages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (current_page > 3) {
        pages.push("...");
      }
      for (
        let i = Math.max(2, current_page - 1);
        i <= Math.min(total_pages - 1, current_page + 1);
        i++
      ) {
        pages.push(i);
      }
      if (current_page < total_pages - 2) {
        pages.push("...");
      }
      pages.push(total_pages);
    }

    return pages;
  };

  const pages = getPages();

  function formatSingleDate(isoDate) {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // or "long" for full month name
    return `${day} ${month}`;
  }


  const fieldBgColor = "white"; 
  const optionHoverColor = "rgba(65, 19, 24, 0.08)"; 
const handleClearFilters = () => {
  const clearedFilters = {
    search: "",
    category_ids: "",
    daterange: { start: null, end: null },
  };

  setFilters(clearedFilters);
  fetchDashboardData(1, clearedFilters); 
};

   const isRTL = i18n.language === 'ar';
  return (
    <div className="inter-font " style={{ minHeight: "100vh" }}>
      <div className="inter-font d-flex justify-content-between align-items-center flex-wrap px-3">
        <h2 className="inter-font inter-font" style={{ fontSize: "19px" }}>
          {t("c_list_4")}{" "}
        </h2>
      </div>

      {/* Filters */}

      {/* Search Input */}
      <div className="inter-font position-relative mb-3">
         {isRTL ?  <CiSearch
                    className="inter-font position-absolute"
                    style={{
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%) scaleX(-1)",
                      pointerEvents: "none",
                    }}
                    size={20}
                  /> : null }
        <input
          type="text"
          placeholder={t("c_ff_text65")}
          className={`inter-font w-100 p-2 rounded-3 ${isRTL ? 'pe-5' : 'ps-5'} py-3 `}
          style={{ paddingLeft: "2.5rem", border: "none" }}
          value={filters.search}
          onChange={(e) => {
            const newFilters = { ...filters, search: e.target.value };
            setFilters(newFilters);
            fetchDashboardDataDebounced(newFilters); 
          }}
        />
         {isRTL ? null : <CiSearch
                    className="inter-font position-absolute"
                    style={{
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                    }}
                    size={20}
                  />}
      </div>

      {/* Filters Row */}
      <div className="inter-font d-flex flex-wrap gap-2 align-items-center mb-3">
        <div style={{ flex: "1 1 150px", minWidth: "150px" }}>
          {/* Category */}
          <Select
            options={[...categoryOptions].sort((a, b) =>
              a.label.localeCompare(b.label)
            )}
            value={
              categoryOptions.find((o) => o.value === filters.category_ids) ||
              null
            }
            onChange={(opt) =>
              setFilters({
                ...filters,
                category_ids: opt?.value || "",
                sub_category_ids: "",
              })
            }
            placeholder={t("new_text_48")}
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                height: 40,
                minHeight: 40,
                fontSize: 14,
                borderRadius: 8,
                border: "none",
                boxShadow: "none",
                backgroundColor: fieldBgColor,
              }),
              valueContainer: (base) => ({ ...base, padding: "0 10px" }),
              placeholder: (base) => ({ ...base, color: "#6c757d" }),
              menu: (base) => ({ ...base, borderRadius: 8, fontSize: 14 }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isFocused ? optionHoverColor : "white",
                color: "#212529",
                padding: "8px 10px",
                cursor: "pointer",
              }),
            }}
          />
        </div>

        {/* Sub-Skills */}
        {/* Sub-Skills */}
        <div style={{ flex: "1 1 150px", minWidth: "150px" }}>
          <Select
            isMulti
            options={[...subCategoryOptions].sort((a, b) =>
              a.label.localeCompare(b.label)
            )}
            value={subCategoryOptions.filter((o) =>
              filters.sub_category_ids?.includes(o.value)
            )}
            onChange={(selected) =>
              setFilters({
                ...filters,
                sub_category_ids: selected
                  ? selected.map((opt) => opt.value)
                  : [],
              })
            }
            placeholder={t("t_d_text43")}
            isClearable
            isDisabled={!filters.category_ids}
            styles={{
              control: (base) => ({
                ...base,
                height: 40,
                minHeight: 40,
                fontSize: 14,
                borderRadius: 8,
                border: "none",
                boxShadow: "none",
                backgroundColor: "white",
              }),
              valueContainer: (base) => ({
                ...base,
                display: "flex",
                flexWrap: "nowrap",
                overflow: "hidden",
                padding: "0 8px",
              }),
              multiValue: (base) => ({
                ...base,
                backgroundColor: "#cd496d",
                borderRadius: 4,
                flexShrink: 0,
                marginRight: 4,
              }),
              multiValueLabel: (base) => ({
                ...base,
                color: "white",
                fontSize: 13,
              }),
              multiValueRemove: (base) => ({
                ...base,
                color: "white",
                ":hover": {
                  backgroundColor: "#a03c58",
                  color: "white",
                },
              }),
              placeholder: (base) => ({
                ...base,
                color: "#6c757d",
              }),
              menu: (base) => ({
                ...base,
                borderRadius: 8,
                backgroundColor: "white",
                fontSize: 14,
                zIndex: 1050,
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isFocused
                  ? "rgba(65,19,24,0.08)"
                  : "white",
                color: "#212529",
                padding: "8px 8px",
                cursor: "pointer",
              }),
            }}
          />
        </div>

        {/* Date Range */}
        <div style={{ flex: "1 1 250px", minWidth: "250px" }}>
          <DateRangePicker
            initialSettings={{ minDate: moment().startOf("day") }}
            onApply={(event, picker) => {
              setFilters({
                ...filters,
                daterange: {
                  start: picker.startDate.toDate(),
                  end: picker.endDate.toDate(),
                },
              });
            }}
            autoUpdateInput={false}
            opens="right"
          >
            <input
              type="text"
              className="form-control"
              placeholder={t("new_text_49")}
              style={{
                height: 40,
                fontSize: 14,
                padding: "0 10px",
                borderRadius: 8,
                border: "none",
                backgroundColor: fieldBgColor,
                boxShadow: "none",
                color: "#212529",
              }}
              value={
                filters.daterange.start && filters.daterange.end
                  ? `${filters.daterange.start.toLocaleDateString()} - ${filters.daterange.end.toLocaleDateString()}`
                  : ""
              }
              readOnly
            />
          </DateRangePicker>

          <style jsx>{`
            .form-control::placeholder {
              color: #6c757d !important;
              opacity: 1;
            }
            .daterangepicker {
              box-shadow: none !important;
              border: 1px solid transparent;
              background-color: ${fieldBgColor};
            }
          `}</style>
        </div>

        {/* Search Button */}
        <button
          className="btn d-flex align-items-center justify-content-center gap-1"
          style={{
            background: "rgba(205, 73, 109, 1)",
            color: "white",
            padding: "0 18px",
            border: "none",
            borderRadius: 8,
            height: 40,
            fontSize: 14,
          }}
          onClick={() => fetchDashboardData(1)}
        >
             {isRTL ? null : <CiSearch size={18} />} 
                  {isRTL ?  <CiSearch
                            style={{
                              transform: " scaleX(-1)",
                            }}
                            size={18}
                          /> : null } 
          {t("c_ff_text68")}
        </button>

        {/* Clear Button */}
        <button
          className="btn d-flex align-items-center justify-content-center gap-1"
          style={{
            background: "rgba(108, 117, 125, 0.9)",
            color: "white",
            padding: "0 18px",
            border: "none",
            borderRadius: 8,
            height: 40,
            fontSize: 14,
          }}
          onClick={handleClearFilters}
        >
          {t("c_ff_text67")} 
        </button>
      </div>

      {/* Recruitment Table */}
      <Container
        className="inter-font bg-white rounded-4 mt-4 p-0 overflow-hidden scrollable-list flex-grow-1"
        style={{ marginTop: "30px" }}
      >
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <p className="mb-0 text-muted">Loading…</p>
          </div>
        ) : recruitmentData?.length === 0 ? (
          <div className="text-center my-4">
            <div style={{ maxWidth: 200, margin: "0 auto" }}>
              <Lottie animationData={NoResultAnimation} loop={true} />
            </div>
          </div>
        ) : (
          <div style={{ overflowX: "auto", width: "100%" }}>
            <div style={{ minWidth: "1000px" }}>
              {recruitmentData.map((talent, idx) => {
                return (
                  <Row
                    key={idx}
                    className="inter-font align-items-start py-3 px-3 border-bottom"
                    style={{ fontFamily: "Inter, sans-serif" }}
                  >
                    <Col
                      xs={2}
                      className="inter-font d-flex align-items-center gap-2 mb-3 mb-md-0"
                    >
                      <Image
                        src={talent?.talent_id?.picture}
                        alt="logo"
                        className="rounded-circle"
                        style={{
                          width: "52px",
                          height: "52px",
                          objectFit: "cover",
                        }}
                      />

                      <div>
                        <div className="inter-font fw-semibold">
                          {" "}
                          {talent?.talent_id?.first_name}{" "}
                          {talent?.talent_id?.last_name}
                        </div>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#888",
                            display: "inline-block",
                            maxWidth: "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            verticalAlign: "middle",
                            ...(isRTL && {
                              direction: "ltr",
                              textAlign: "left",
                            }),
                          }}
                          title={talent?.talent_id?.email}
                        >
                          {talent?.talent_id?.email}
                        </div>
                      </div>
                    </Col>

                    <Col xs={2} className="inter-font mb-3 mb-md-0">
                      <div className="inter-font fw-semibold">
                        {t("t_d_text41")}
                      </div>
                      <div style={{ fontSize: "14px", color: "#555" }}>
                        {talent?.skill_id?.title || "-"}
                      </div>
                    </Col>
                    <Col xs={2} className="inter-font mb-3 mb-md-0">
                      <div className="inter-font fw-semibold">
                        {t("t_d_text42")}
                      </div>
                      <div style={{ fontSize: "14px", color: "#555" }}>
                        {talent?.sub_skill_id?.title || "-"}
                      </div>
                    </Col>
                    {/* <Col  xs={2} className="inter-font mb-3 mb-md-0">
                <div className="inter-font fw-semibold">Skill</div>
                <div style={{ fontSize: "14px", color: "#555" }}>
                  {talent?.job_category?.title || "-"}
                </div>
              </Col> */}

                    <Col xs={1} className="inter-font mb-3 mb-md-0">
                      <div className="inter-font fw-semibold mb-1">
                        {t("t_d_text96")}
                      </div>
                      <span
                        style={{
                          background:
                            talent?.status === "Accepted"
                              ? "rgba(0,194,95,1)"
                              : "rgba(233,123,110,1)",
                          color: "white",
                          borderRadius: "10px",
                          padding: "4px 12px",
                          fontSize: "13px",
                        }}
                      >
                        {talent?.status === "Accepted"
                          ? "Active"
                          : "Expired/Closed"}
                      </span>
                    </Col>

                    <Col xs={2} className="inter-font mb-3 mb-md-0">
                      <div
                        className="inter-font fw-semibold mb-1"
                        style={{ textAlign: isRTL ? "end" : "start" }}
                      >
                        {t("t_d_text99")}
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#555",
                          direction: "ltr",
                        }}
                      >
                        {formatSingleDate(talent?.start_date)} -{" "}
                        {formatSingleDate(talent?.end_date)}
                      </div>
                    </Col>

                    <Col
                      xs={1}
                      className="inter-font mb-3 mb-md-0"
                      style={{ textAlign: isRTL ? "end" : "start" }}
                    >
                      <div className="inter-font fw-semibold mb-1">
                        {t("t_d_text97")}
                      </div>
                      <span style={{ fontSize: "14px", color: "#555",     direction: "ltr",
    unicodeBidi: "plaintext"  }}>
                        {talent?.duration}
                      </span>
                      {/* {talent?.start_date ? (
                  <>
                    <div className="inter-font fw-semibold mb-1">Period</div>
                    <div style={{ fontSize: "14px", color: "#555" }}>
                      {formatSingleDate(talent?.start_date)} - {formatSingleDate(talent?.end_date)}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="inter-font fw-semibold mb-1">Experience</div>
                    <div style={{ fontSize: "14px", color: "#555" }}>
                      {person.experience}
                    </div>
                  </>
                )} */}
                    </Col>

                    <Col xs={2}>
                      {/* {person.project ? (
                  <>
                    <div className="inter-font fw-semibold mb-1">Project</div>
                    <div className="inter-font fw-bold" style={{ color: "#999" }}>
                      {person.project}
                    </div>person
                  </>
                ) : ( */}
                      <>
                        <div className="inter-font fw-semibold mb-1" style={{ textAlign: isRTL ? "end" : "start" }}>
                          {t("c_t_text1")}
                        </div>
                        <div style={{ fontSize: "14px", color: "#555",     direction: "ltr",
    unicodeBidi: "plaintext"  }}>
                          {talent?.project_id?.title
                            ? talent.project_id.title
                                .split(" ")
                                .slice(0, 3)
                                .join(" ") +
                              (talent.project_id.title.split(" ").length > 3
                                ? "..."
                                : "")
                            : ""}
                        </div>
                      </>
                      {/* )} */}
                    </Col>
                  </Row>
                );
              })}
            </div>
          </div>
        )}
      </Container>

      {/* Pagination */}
      {pagination?.total_pages > 1 && (
        <Paginator
          page={pagination.current_page}
          rows={pagination.per_page}
          totalRecords={pagination.total_records}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default Recruitment;
